export default __webpack_public_path__ + "static/media/discharge.a0eed96e.svg";